var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKeyboardFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "keys",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H23.4015C23.7307 0 24 0.297307 24 0.660683V19.0937C24 19.5232 23.8204 19.9196 23.5212 20.1508L12.7182 28.971C12.2993 29.3013 11.7307 29.3013 11.2818 28.971L0.478803 20.1839C0.179551 19.9196 0 19.5232 0 19.1268V0.660683C0 0.297307 0.269327 0 0.598504 0H12Z",
    fill: "#2D9CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21951 7.9041H2.63347C2.424 7.9041 2.24445 7.70567 2.24445 7.47417V0H4.63846V7.4411C4.63846 7.70567 4.45891 7.9041 4.21951 7.9041Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41162 7.90417V15.7421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63088 7.9041H6.04485C5.83537 7.9041 5.65582 7.70567 5.65582 7.47417V0H8.04984V7.4411C8.01991 7.70567 7.84036 7.9041 7.63088 7.9041Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.823 7.90417V15.7421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2642 0V15.7421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.7422H0",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4538 7.9041H12.8678C12.6583 7.9041 12.4788 7.70567 12.4788 7.47417V0H14.8728V7.4411C14.8428 7.70567 14.6633 7.9041 14.4538 7.9041Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6459 7.90417V15.7421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8954 7.9041H16.3093C16.0998 7.9041 15.9203 7.70567 15.9203 7.47417V0H18.3143V7.4411C18.2844 7.70567 18.1048 7.9041 17.8954 7.9041Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0872 7.90417V15.7421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3665 7.9041H19.7505C19.5411 7.9041 19.3615 7.70567 19.3615 7.47417V0H21.7555V7.4411C21.7555 7.70567 21.576 7.9041 21.3665 7.9041Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5586 7.90417V15.7421",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardFill);
export default __webpack_public_path__ + "static/media/icon-keyboard-fill.5cd2b1ad441b6fe0a92ca22708acc0c2.svg";
export { ForwardRef as ReactComponent };